import { connect } from 'react-redux';
import LayerManager from '../../components/LayerManager/LayerManager';
import * as actionsCoupleCoverage from '../../actions/CouplesCoverageActions';
import * as actionsMapHandler from '../../actions/MapActionsHandler';
import * as actionsNoiseSamples from '../../actions/NoiseSamplesActions';
import * as mobileSamplesActions from '../../actions/MobileSamplesActions';
import { featuresTypes } from '../../components/Map/Layers/Options';
import * as types from '../../constants/ActionTypes';

const mapStateToProps = (state, ownProps) => {
  const projectId = state.leaksList.selectedProject;
  const project = state.leaksList.projectsList.items[state.leaksList.projectsList.projectIndexMap[projectId]]
  const coupleCoverageData =
    state.leaksList.leaksByProject[projectId] &&
    state.leaksList.leaksByProject[projectId].couplesCoveragePaths;
  const bHaveCoupleCoverageData =
    coupleCoverageData &&
    coupleCoverageData.data &&
    coupleCoverageData.paths.length > 0;
  const mapLayers = state.mapState.layers;
  let newProps = Object.assign({}, ownProps, {
    layers: Object.assign(mapLayers, ownProps.layers),
  });
  const noiseSamplesColorAttr = state.local.noiseSamplesColorAttr;
  const mobileNoiseSamplesColorAttr = state.local.mobileNoiseSamplesColorAttr;

  return Object.assign(
    {},
    {
      project,
      noiseSamplesColorAttr,
      mobileNoiseSamplesColorAttr,
      coupleCoverage: {
        hasData: bHaveCoupleCoverageData,
        isFetching: coupleCoverageData && coupleCoverageData.isFetching,
      },
    },
    newProps
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onLayerChange: (event, layerName) => {
      const isChecked = event.target.checked;
      
      // For couples coverage
      if (layerName === featuresTypes.COUPLES_COVERAGE && isChecked) {
        dispatch((dispatch, getState) => {
          const state = getState();
          const selectedProjectId = state.leaksList.selectedProject;
          const coupleCoverageData = state.leaksList.leaksByProject[selectedProjectId].couplesCoveragePaths;
          
          if (coupleCoverageData.isFetching === true ||
              (coupleCoverageData != null &&
               coupleCoverageData.paths != null &&
               coupleCoverageData.paths.length > 0)) {
            dispatch(actionsMapHandler.handleLayerChange(layerName, isChecked));
          } else {
            dispatch(actionsCoupleCoverage.FetchCouplesCoveragePathsIfNeeded(true));
          }
        });
        return;
      }
      
      // Default handling for all other layers
      dispatch(actionsMapHandler.handleLayerChange(layerName, isChecked));
    },
    
    reloadCoupleCoverage: (event) => {
      dispatch(actionsCoupleCoverage.FetchCouplesCoveragePathsIfNeeded());
    },
    
    noiseSamplesSourceChange: (event, value) => {
      dispatch((dispatch, getState) => {
        const state = getState();
        const project = state.leaksList.selectedProject;
        dispatch(actionsNoiseSamples.setNoiseColorByAttribute(project, value));
      });
    },
    
    mobileNoiseSamplesSourceChange: (event, value) => {
      dispatch(mobileSamplesActions.setMobileNoiseColorByAttribute(value));
    },
    
    getState: () => {
      return (dispatch, getState) => {
        const state = getState();
        const project = state.leaksList.selectedProject;
        if (project) {
          dispatch(actionsNoiseSamples.fetchNoiseSamplesIfNeeded(project, true));
        }
        return state;
      };
    },
    
    fetchNoiseSamplesIfNeeded: (project, force) => {
      dispatch(actionsNoiseSamples.fetchNoiseSamplesIfNeeded(project, force));
    },
  };
};

const CLayersManager = connect(
  mapStateToProps,
  mapDispatchToProps
)(LayerManager);

export default CLayersManager;
